import { $ as jquery } from 'jquery';

var $ = jquery;
var jQuery = jquery;

if (typeof window !== 'undefined') {
  window.layui = window.layui || {};
  window.layui.jquery = window.layui.jquery || $;
  window.$ = window.$ || $;
  window.jQuery = window.jQuery || $;
}

var dragsort = (function () {
  (function ($) {
    var INSTANCE_KEY = 'layui.dragsort.instance';
    var DEFAULTS = {
      itemSelector: '',
      dragSelector: '',
      dragSelectorExclude: 'input, textarea',
      dragEnd: function () {},
      dragBetween: false,
      dragBetweenLeftNum: 0,
      dragBetweenRightNum: 0,
      dragBetweenLeft: '',
      dragBetweenRight: '',
      placeHolderTemplate: '',
      scrollContainer: window,
      scrollSpeed: 5,
    };

    function normalizeContainer(container) {
      if ($(container).is('table') && $(container).children().length === 1 && $(container).children().is('tbody')) {
        return $(container).children().get(0);
      }
      return container;
    }

    function getGroupKey($elements) {
      return (
        $elements
          .map(function () {
            return this;
          })
          .get()
          .join('|') || Math.random().toString(36).slice(2, 10)
      );
    }

    function destroyInstance(element) {
      var instance = $(element).data(INSTANCE_KEY);
      if (instance && typeof instance.destroy === 'function') {
        instance.destroy();
      }
    }

    function DragSortGroup($elements, options) {
      this.$elements = $elements;
      this.options = $.extend({}, DEFAULTS, options || {});
      this.ns = '.dragsort_' + Math.random().toString(36).slice(2, 10);
      this.groupKey = getGroupKey($elements);
      this.lists = [];
      this.activeList = null;
      this.lastPos = null;
      this.init();
    }

    DragSortGroup.prototype.init = function () {
      var group = this;

      this.$elements.each(function (index, element) {
        var container = normalizeContainer(element);
        var list = new DragSortList(group, index, container);
        group.lists.push(list);
        list.init();
        $(element).data(INSTANCE_KEY, group);
        if (container !== element) {
          $(container).data(INSTANCE_KEY, group);
        }
      });
    };

    DragSortGroup.prototype.destroy = function () {
      this.cleanupDragArtifacts();
      this.unbindDocumentEvents();
      this.lists.forEach(function (list) {
        list.destroy();
      });
      this.lists = [];
      this.$elements.each(function () {
        $(this).removeData(INSTANCE_KEY);
      });
    };

    DragSortGroup.prototype.cleanupDragArtifacts = function () {
      this.stopAutoScroll();
      $('[data-droptarget], .dragSortItem').remove();
      if (this.activeList && this.activeList.placeHolderItem) {
        this.activeList.placeHolderItem.remove();
      }
      this.activeList = null;
      this.lastPos = null;
    };

    DragSortGroup.prototype.stopAutoScroll = function () {
      if (!this.activeList || !this.activeList.scroll) {
        return;
      }
      window.clearInterval(this.activeList.scroll.scrollY);
      window.clearInterval(this.activeList.scroll.scrollX);
      this.activeList.scroll = null;
    };

    DragSortGroup.prototype.bindDocumentEvents = function () {
      var group = this;
      $(document)
        .off('mousemove' + this.ns, this.swapItemsBound)
        .off('mouseup' + this.ns, this.dropItemBound);

      this.swapItemsBound = function (event) {
        return group.swapItems(event);
      };
      this.dropItemBound = function () {
        return group.dropItem();
      };

      $(document).on('mousemove' + this.ns, this.swapItemsBound);
      $(document).on('mouseup' + this.ns, this.dropItemBound);

      if (this.options.scrollContainer !== window) {
        this.wheelBound = function (event) {
          group.wheel(event);
        };
        $(window).on('wheel' + this.ns, this.wheelBound);
      }
    };

    DragSortGroup.prototype.unbindDocumentEvents = function () {
      $(document).off(this.ns);
      $(window).off(this.ns);
      this.swapItemsBound = null;
      this.dropItemBound = null;
      this.wheelBound = null;
    };

    DragSortGroup.prototype.startDrag = function (list, event) {
      if (this.activeList && this.activeList.draggedItem) {
        this.dropItem();
      }

      this.activeList = list;
      this.lastPos = null;
      list.dragStart(event);
      this.bindDocumentEvents();
    };

    DragSortGroup.prototype.swapItems = function (event) {
      var list = this.activeList;
      var hitIndex = -1;
      var targetList = list;
      var i;
      var children;
      var fixed;

      if (!list || !list.draggedItem) {
        return false;
      }

      list.setPos(event.pageX, event.pageY);
      hitIndex = list.findPos(event.pageX, event.pageY);

      if (hitIndex === -1 && this.options.dragBetween) {
        for (i = 0; i < this.lists.length; i++) {
          hitIndex = this.lists[i].findPos(event.pageX, event.pageY);
          if (hitIndex !== -1) {
            targetList = this.lists[i];
            break;
          }
        }
      }

      if (hitIndex === -1) {
        return false;
      }

      children = function () {
        return $(targetList.container).children().not(targetList.draggedItem);
      };

      fixed = children()
        .not(this.options.itemSelector)
        .each(function () {
          this.idx = children().index(this);
        });

      if (
        this.lastPos == null ||
        this.lastPos.top > list.draggedItem.offset().top ||
        this.lastPos.left > list.draggedItem.offset().left
      ) {
        $(targetList.pos[hitIndex].elm).before(list.placeHolderItem);
      } else {
        $(targetList.pos[hitIndex].elm).after(list.placeHolderItem);
      }

      fixed.each(function () {
        var elm = children().eq(this.idx).get(0);
        if (this !== elm && children().index(this) < this.idx) {
          $(this).insertAfter(elm);
        } else if (this !== elm) {
          $(this).insertBefore(elm);
        }
      });

      this.lists.forEach(function (item) {
        item.createDropTargets();
        item.buildPositionTable();
      });

      this.lastPos = list.draggedItem.offset();
      return false;
    };

    DragSortGroup.prototype.dropItem = function () {
      var list = this.activeList;
      var origPos;
      var nextItem;

      if (!list || !list.draggedItem) {
        return false;
      }

      list.draggedItem.removeAttr('style');
      list.styleDragHandlers(true);
      list.placeHolderItem.before(list.draggedItem);
      list.placeHolderItem.remove();

      $('[data-droptarget], .dragSortItem').remove();
      this.stopAutoScroll();

      if (
        list.draggedItem.attr('data-origpos') !==
        this.lists.indexOf(list) + '-' + $(list.container).children().index(list.draggedItem)
      ) {
        if (this.options.dragEnd.apply(list.draggedItem) === false) {
          origPos = list.draggedItem.attr('data-origpos').split('-');
          nextItem = $(this.lists[origPos[0]].container).children().not(list.draggedItem).eq(origPos[1]);
          if (nextItem.length > 0) {
            nextItem.before(list.draggedItem);
          } else if (Number(origPos[1]) === 0) {
            $(this.lists[origPos[0]].container).prepend(list.draggedItem);
          } else {
            $(this.lists[origPos[0]].container).append(list.draggedItem);
          }
        }
      }

      list.draggedItem.removeAttr('data-origpos');
      list.draggedItem = null;
      list.placeHolderItem = null;
      this.unbindDocumentEvents();
      this.activeList = null;
      this.lastPos = null;
      return false;
    };

    DragSortGroup.prototype.wheel = function (event) {
      var list = this.activeList;
      var cont;
      var offset;
      var originalEvent;
      var deltaY;

      if (!list || this.options.scrollContainer === window) {
        return;
      }

      cont = $(this.options.scrollContainer);
      offset = cont.offset();
      originalEvent = event.originalEvent;

      if (
        originalEvent.clientX > offset.left &&
        originalEvent.clientX < offset.left + cont.width() &&
        originalEvent.clientY > offset.top &&
        originalEvent.clientY < offset.top + cont.height()
      ) {
        deltaY = (originalEvent.deltaMode === 0 ? 1 : 10) * originalEvent.deltaY;
        cont.scrollTop(cont.scrollTop() + deltaY);
        event.preventDefault();
      }
    };

    function DragSortList(group, index, container) {
      this.group = group;
      this.index = index;
      this.container = container;
      this.draggedItem = null;
      this.placeHolderItem = null;
      this.pos = null;
      this.offset = null;
      this.offsetLimit = null;
      this.scroll = null;
      this.triggerHandler = null;
      this.releaseHandler = null;
    }

    DragSortList.prototype.getTagName = function () {
      return $(this.container).children().length === 0
        ? 'li'
        : $(this.container).children().get(0).tagName.toLowerCase();
    };

    DragSortList.prototype.ensureOptions = function () {
      var options = this.group.options;
      options.tagName = this.getTagName();
      if (options.itemSelector === '') {
        options.itemSelector = options.tagName;
      }
      if (options.dragSelector === '') {
        options.dragSelector = options.tagName;
      }
      if (options.placeHolderTemplate === '') {
        options.placeHolderTemplate = '<' + options.tagName + '>&nbsp;</' + options.tagName + '>';
      }
    };

    DragSortList.prototype.init = function () {
      this.ensureOptions();
      $(this.container).attr('data-listidx', this.index);
      this.bind();
      this.styleDragHandlers(true);
    };

    DragSortList.prototype.destroy = function () {
      this.unbind();
      this.styleDragHandlers(false);
      $(this.container).removeAttr('data-listidx');
    };

    DragSortList.prototype.bind = function () {
      var list = this;
      $(this.container).on('mousedown' + this.group.ns, function (event) {
        return list.grabItem(event);
      });
    };

    DragSortList.prototype.unbind = function () {
      $(this.container).off(this.group.ns);
    };

    DragSortList.prototype.getItems = function () {
      return $(this.container).children(this.group.options.itemSelector);
    };

    DragSortList.prototype.styleDragHandlers = function (cursor) {
      var options = this.group.options;
      this.getItems()
        .map(function () {
          return $(this).is(options.dragSelector) ? this : $(this).find(options.dragSelector).get();
        })
        .css('cursor', cursor ? 'pointer' : '');
    };

    DragSortList.prototype.grabItem = function (event) {
      var options = this.group.options;
      var item;
      var insideMoveableItem;
      var dragHandle;
      var list = this;

      if (
        $(event.currentTarget).hasClass(options.dragBetweenRight) &&
        $('.' + options.dragBetweenLeft + ' ' + options.dragSelector).length >= options.dragBetweenLeftNum
      ) {
        return;
      }

      item = $(event.target).closest('[data-listidx] > ' + options.tagName).get(0);
      insideMoveableItem = this.getItems().filter(function () {
        return this === item;
      }).length > 0;

      if (
        event.which !== 1 ||
        $(event.target).is(options.dragSelectorExclude) ||
        $(event.target).closest(options.dragSelectorExclude).length > 0 ||
        !insideMoveableItem
      ) {
        return;
      }

      event.preventDefault();

      dragHandle = event.target;
      while (!$(dragHandle).is(options.dragSelector)) {
        if (dragHandle === event.currentTarget) {
          return;
        }
        dragHandle = dragHandle.parentNode;
      }

      $(dragHandle).attr('data-cursor', $(dragHandle).css('cursor')).css('cursor', 'move');

      this.triggerHandler = function () {
        list.group.startDrag(list, event);
        $(list.container).off('mousemove' + list.group.ns, list.triggerHandler);
      };

      this.releaseHandler = function () {
        $(list.container).off('mousemove' + list.group.ns, list.triggerHandler);
        $(dragHandle).css('cursor', $(dragHandle).attr('data-cursor'));
        $(list.container).off('mouseup' + list.group.ns, list.releaseHandler);
      };

      $(this.container).on('mousemove' + this.group.ns, this.triggerHandler);
      $(this.container).on('mouseup' + this.group.ns, this.releaseHandler);
    };

    DragSortList.prototype.dragStart = function (event) {
      var options = this.group.options;
      var marginTop;
      var marginLeft;
      var containerHeight;
      var height;
      var width;
      var origStyle;
      var listTable;
      var list = this;

      this.draggedItem = $(event.target).closest('[data-listidx] > ' + options.tagName);
      this.draggedItem.attr('data-origpos', this.index + '-' + $(this.container).children().index(this.draggedItem));

      marginTop = parseInt(this.draggedItem.css('marginTop'), 10);
      marginLeft = parseInt(this.draggedItem.css('marginLeft'), 10);
      this.offset = this.draggedItem.offset();
      this.offset.top = event.pageY - this.offset.top + (isNaN(marginTop) ? 0 : marginTop) - 1;
      this.offset.left = event.pageX - this.offset.left + (isNaN(marginLeft) ? 0 : marginLeft) - 1;

      if (!options.dragBetween) {
        containerHeight =
          $(this.container).outerHeight() === 0
            ? Math.max(
                1,
                Math.round(
                  0.5 +
                    (this.getItems().length * this.draggedItem.outerWidth()) / $(this.container).outerWidth(),
                ),
              ) * this.draggedItem.outerHeight()
            : $(this.container).outerHeight();
        this.offsetLimit = $(this.container).offset();
        this.offsetLimit.right = this.offsetLimit.left + $(this.container).outerWidth() - this.draggedItem.outerWidth();
        this.offsetLimit.bottom = this.offsetLimit.top + containerHeight - this.draggedItem.outerHeight();
      }

      height = this.draggedItem.height();
      width = this.draggedItem.width();

      if (options.tagName === 'tr') {
        this.draggedItem.children().each(function () {
          $(this).width($(this).width());
        });
        this.placeHolderItem = this.draggedItem.clone().attr('data-placeholder', true);
        this.draggedItem.after(this.placeHolderItem);
        this.placeHolderItem.children().each(function () {
          $(this)
            .css({ borderWidth: 0, width: $(this).width() + 1, height: $(this).height() + 1 })
            .html('&nbsp;');
        });
      } else {
        this.draggedItem.after(options.placeHolderTemplate);
        this.placeHolderItem = this.draggedItem.next().css({ height: height, width: width }).attr('data-placeholder', true);
      }

      if (options.tagName === 'td') {
        listTable = this.draggedItem.closest('table').get(0);
        $("<table id='" + listTable.id + "' style='border-width: 0px;' class='dragSortItem " + listTable.className + "'><tr></tr></table>")
          .appendTo('body')
          .children()
          .append(this.draggedItem);
      }

      origStyle = this.draggedItem.attr('style');
      this.draggedItem.attr('data-origstyle', origStyle ? origStyle : '');
      this.draggedItem.css({ position: 'absolute', opacity: 0.8, zIndex: 999, height: height, width: width });

      this.scroll = {
        moveX: 0,
        moveY: 0,
        maxX: $(document).width() - $(window).width(),
        maxY: $(document).height() - $(window).height(),
      };

      this.scroll.scrollY = window.setInterval(function () {
        var topValue;
        if (options.scrollContainer !== window) {
          $(options.scrollContainer).scrollTop($(options.scrollContainer).scrollTop() + list.scroll.moveY);
          return;
        }
        topValue = $(options.scrollContainer).scrollTop();
        if (
          (list.scroll.moveY > 0 && topValue < list.scroll.maxY) ||
          (list.scroll.moveY < 0 && topValue > 0)
        ) {
          $(options.scrollContainer).scrollTop(topValue + list.scroll.moveY);
          list.draggedItem.css('top', list.draggedItem.offset().top + list.scroll.moveY + 1);
        }
      }, 10);

      this.scroll.scrollX = window.setInterval(function () {
        var leftValue;
        if (options.scrollContainer !== window) {
          $(options.scrollContainer).scrollLeft($(options.scrollContainer).scrollLeft() + list.scroll.moveX);
          return;
        }
        leftValue = $(options.scrollContainer).scrollLeft();
        if (
          (list.scroll.moveX > 0 && leftValue < list.scroll.maxX) ||
          (list.scroll.moveX < 0 && leftValue > 0)
        ) {
          $(options.scrollContainer).scrollLeft(leftValue + list.scroll.moveX);
          list.draggedItem.css('left', list.draggedItem.offset().left + list.scroll.moveX + 1);
        }
      }, 10);

      this.group.lists.forEach(function (item) {
        item.createDropTargets();
        item.buildPositionTable();
      });
      this.setPos(event.pageX, event.pageY);
    };

    DragSortList.prototype.setPos = function (x, y) {
      var options = this.group.options;
      var top = y - this.offset.top;
      var left = x - this.offset.left;
      var parent;
      var cont;
      var offset;

      if (!options.dragBetween) {
        top = Math.min(this.offsetLimit.bottom, Math.max(top, this.offsetLimit.top));
        left = Math.min(this.offsetLimit.right, Math.max(left, this.offsetLimit.left));
      }

      parent = this.draggedItem.offsetParent().not('body').offset();
      if (parent != null) {
        top -= parent.top;
        left -= parent.left;
      }

      if (options.scrollContainer === window) {
        y -= $(window).scrollTop();
        x -= $(window).scrollLeft();
        y = Math.max(0, y - $(window).height() + 5) + Math.min(0, y - 5);
        x = Math.max(0, x - $(window).width() + 5) + Math.min(0, x - 5);
      } else {
        cont = $(options.scrollContainer);
        offset = cont.offset();
        y = Math.max(0, y - cont.height() - offset.top) + Math.min(0, y - offset.top);
        x = Math.max(0, x - cont.width() - offset.left) + Math.min(0, x - offset.left);
      }

      this.scroll.moveX = x === 0 ? 0 : (x * options.scrollSpeed) / Math.abs(x);
      this.scroll.moveY = y === 0 ? 0 : (y * options.scrollSpeed) / Math.abs(y);
      this.draggedItem.css({ top: top, left: left });
    };

    DragSortList.prototype.buildPositionTable = function () {
      var activeList = this.group.activeList;
      var pos = [];

      this.getItems()
        .not([
          activeList && activeList.draggedItem ? activeList.draggedItem[0] : null,
          activeList && activeList.placeHolderItem ? activeList.placeHolderItem[0] : null,
        ])
        .each(function (index) {
          var loc = $(this).offset();
          loc.right = loc.left + $(this).outerWidth();
          loc.bottom = loc.top + $(this).outerHeight();
          loc.elm = this;
          pos[index] = loc;
        });
      this.pos = pos;
    };

    DragSortList.prototype.findPos = function (x, y) {
      var i;
      if (!this.pos) {
        return -1;
      }
      for (i = 0; i < this.pos.length; i++) {
        if (this.pos[i].left < x && this.pos[i].right > x && this.pos[i].top < y && this.pos[i].bottom > y) {
          return i;
        }
      }
      return -1;
    };

    DragSortList.prototype.createDropTargets = function () {
      var options = this.group.options;
      var activeList = this.group.activeList;

      if (!options.dragBetween || !activeList || !activeList.placeHolderItem) {
        return;
      }

      this.group.lists.forEach(function (item) {
        var ph = $(item.container).find('[data-placeholder]');
        var dt = $(item.container).find('[data-droptarget]');
        if (ph.length > 0 && dt.length > 0) {
          dt.remove();
        } else if (ph.length === 0 && dt.length === 0) {
          if (options.tagName === 'td') {
            $(options.placeHolderTemplate).attr('data-droptarget', true).appendTo(item.container);
          } else {
            $(item.container).append(
              activeList.placeHolderItem.removeAttr('data-placeholder').clone().attr('data-droptarget', true),
            );
          }
          activeList.placeHolderItem.attr('data-placeholder', true);
        }
      });
    };

    $.fn.dragsort = function (options) {
      if (options === 'destroy') {
        return this.each(function () {
          destroyInstance(this);
        });
      }

      if (!this.length) {
        return this;
      }

      this.each(function () {
        destroyInstance(this);
      });

      new DragSortGroup(this, options);
      return this;
    };

    $.fn.dragsort.defaults = DEFAULTS;
  })(jQuery);
  return $.fn.dragsort;
})();

if (typeof window !== 'undefined') {
  window.layui = window.layui || {};
  window.layui.dragsort = dragsort;
  if (window.jQuery) {
    window.jQuery.fn.dragsort = $.fn.dragsort;
  }
}

export { dragsort };
